import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-4, message, chat" maskId="round-filled-radius-0-stroke-1.5-IconBubble4"><path d="M20.252 3C20.6662 3 21.002 3.33579 21.002 3.75V19.25C21.002 19.6642 20.6662 20 20.252 20H7.96705L4.14945 22.386C3.91825 22.5305 3.62684 22.5382 3.38838 22.406C3.14991 22.2738 3.00195 22.0226 3.00195 21.75V3.75C3.00195 3.33579 3.33774 3 3.75195 3H20.252Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble4;
